import { render, staticRenderFns } from "./yoyo-stats.vue?vue&type=template&id=b40a5428&scoped=true&"
import script from "./yoyo-stats.vue?vue&type=script&lang=js&"
export * from "./yoyo-stats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40a5428",
  null
  
)

export default component.exports